<div class="d-flex flex-wrap mb-2" role="tablist" aria-label="Music sources">
  <button *ngFor="let tab of sourceTabs" type="button" role="tab" class="btn btn-sm rounded-pill mr-1 mb-1"
    [ngClass]="activeSource == tab.key ? 'btn-primary' : 'btn-outline-secondary text-light'"
    [attr.aria-selected]="activeSource == tab.key" (click)="activeSource = tab.key">
    {{ tab.label }}
    <span *ngIf="sourceCount(tab.key)" class="badge badge-pill badge-light ml-1">{{ sourceCount(tab.key) }}</span>
    <span *ngIf="sourceError(tab.key) as error" class="badge badge-pill badge-danger ml-1" [title]="error" [attr.aria-label]="error">!</span>
  </button>
</div>

<section *ngIf="activeSource == 'links'" class="mb-3">
  <textarea class="form-control bg-transparent border-secondary text-light" rows="3" aria-label="Paste links"
    [placeholder]="mode == 'mix_lyric'
      ? 'https://www.deezer.com/en/track/15597831\nhttps://soundhex.com/timestamp/31381'
      : 'https://www.youtube.com/watch?v=7wtfhZwyrcc\nhttps://www.deezer.com/en/track/15597831\nhttps://open.spotify.com/track/4w1lzcaoZ1IC2K5TwjalRP\nhttp://lyric.moonmusic.top/src/uploads/SQ5bEk8oGq_1680142133858.mp3'"
    [ngModel]="compData?.link_text" (input)="linkTextChange($event)"
    (paste)="linkTextChange($event)"></textarea>
</section>

<section *ngIf="activeSource == 'booms'" class="mb-3">

  <div *ngFor="let boom of compData?.booms; let i = index" class="row align-items-center mb-3">
    <mat-form-field appearance="fill" class="col-md">
      <mat-label>Choose a genre</mat-label>
      <mat-select [compareWith]="editorService.matCompareWith" [ngModel]="compData?.booms[i]?.genre"
        (ngModelChange)="boomGenreChange($event, 'booms', i)"
        disableOptionCentering #genreSelect (openedChange)="$event && scrollPanelTop(genreSelect)">
        <mat-select-trigger class="text-light">
          {{ compData?.booms[i]?.genre || '' }}
        </mat-select-trigger>

        <mat-optgroup>
          <mat-form-field class="w-100">
            <input matInput placeholder="Search" #boomFilter (keydown)="$event.stopPropagation()">
          </mat-form-field>
        </mat-optgroup>

        <mat-option *ngFor="let item of boomGenres" [value]="item?.name"
          [ngClass]="{ 'd-none': !item?.name.toLowerCase().includes(boomFilter.value.toLowerCase()) }">
          {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-md-6">
      <mat-label>Choose musics</mat-label>
      <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="compData?.booms[i]?.musics"
        (ngModelChange)="boomMusicChange($event, 'booms', i)" multiple
        disableOptionCentering #boomSelect (openedChange)="$event && scrollPanelTop(boomSelect)">
        <mat-select-trigger class="text-light">
          {{ compData?.booms[i]?.musics ? compData?.booms[i].musics[0]?.song_name : '' }}
          <span *ngIf="compData?.booms[i]?.musics?.length > 1">
            (+{{ compData?.booms[i].musics.length - 1 }}
            {{ compData?.booms[i].musics.length == 2 ? 'other' : 'others' }})
          </span>
        </mat-select-trigger>

        <mat-optgroup>
          <mat-form-field class="w-100">
            <input matInput placeholder="Search" #boomMusicFilter (keydown)="$event.stopPropagation()">
          </mat-form-field>
        </mat-optgroup>

        <mat-option *ngFor="let m of boomMusic.booms[i]; let j = index" [value]="m"
          [ngClass]="{ 'd-none': !(m?.id + ' ' + m?.song_name.toLowerCase() + ' ' + m?.artist.toLowerCase()).includes(boomMusicFilter.value.toLowerCase()) }">
          <svg *ngIf="m?.direct_link" (click)="$event.stopPropagation(); playAudio(m, j)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" 
              [attr.fill]="isPlaying(m, j) ? 'red' : 'currentColor'" class="bi mr-2 c-pointer" viewBox="0 0 16 16">
            <path *ngIf="!isPlaying(m, j)" d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
            <path *ngIf="isPlaying(m, j)" d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
          </svg>
          {{ m.song_name }} - {{ m.artist }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-1 d-flex align-items-center p-0">
      <svg (click)="removeRow('booms', i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
        class="bi bi-trash mr-2 c-pointer" viewBox="0 0 16 16">
        <path
          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
        <path
          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
      </svg>

      <svg (click)="newRow('booms')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
        class="bi bi-plus-lg c-pointer" viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
      </svg>
    </div>
  </div>
</section>

<section *ngIf="activeSource == 'groups'" class="mb-3">
  <div *ngFor="let group of compData?.groups; let i = index" class="row align-items-center mb-3">
    <mat-form-field appearance="fill" class="col-md">
      <mat-label>Choose a group</mat-label>
      <mat-select [compareWith]="editorService.matCompareWith" [ngModel]="compData?.groups[i]?.genre"
        (ngModelChange)="boomGenreChange($event, 'groups', i)"
        disableOptionCentering #groupSelect (openedChange)="$event && scrollPanelTop(groupSelect)">
        <mat-select-trigger class="text-light">
          {{ editorService.getGroupName(compData?.groups[i]?.genre, boomGroups) }}
        </mat-select-trigger>

        <mat-optgroup>
          <mat-form-field class="w-100">
            <input matInput placeholder="Search" #groupFilter (keydown)="$event.stopPropagation()">
          </mat-form-field>
        </mat-optgroup>

        <mat-option *ngFor="let item of boomGroups" [value]="'GROUP__' + item?.id"
          [ngClass]="{
            'd-none': !item?.name.toLowerCase().includes(groupFilter.value.toLowerCase()),
            'bg-success text-white': item.type === 'EPIC',
            'text-info': item.type === 'OFFICIAL',
            'text-secondary': item.type === 'AI',
            'text-purple': item.type === 'SYMP'
          }">
          <span *ngIf="item?.type !== 'NORMAL'" class="badge badge-light">{{ item?.type }}</span>
          {{ item?.name }} ({{ item?.vip }} vip, {{ item?.normal }} normal)
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-md-6">
      <mat-label>Choose musics</mat-label>
      <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="compData?.groups[i]?.musics"
        (ngModelChange)="boomMusicChange($event, 'groups', i)" multiple
        disableOptionCentering #groupMusicSelect (openedChange)="$event && scrollPanelTop(groupMusicSelect)">
        <mat-select-trigger class="text-light">
          {{ compData?.groups[i]?.musics ? compData?.groups[i].musics[0]?.song_name : '' }}
          <span *ngIf="compData?.groups[i]?.musics?.length > 1">
            (+{{ compData?.groups[i].musics.length - 1 }}
            {{ compData?.groups[i].musics.length == 2 ? 'other' : 'others' }})
          </span>
        </mat-select-trigger>

        <mat-optgroup>
          <mat-form-field class="w-100">
            <input matInput placeholder="Search" #groupMusicFilter (keydown)="$event.stopPropagation()">
          </mat-form-field>
        </mat-optgroup>

        <mat-option *ngFor="let m of boomMusic.groups[i]; let j = index" [value]="m"
          [ngClass]="{ 'd-none': !(m?.id + ' ' + m?.song_name.toLowerCase() + ' ' + m?.artist.toLowerCase()).includes(groupMusicFilter.value.toLowerCase()) }">
          <svg *ngIf="m?.direct_link" (click)="$event.stopPropagation(); playAudio(m, j)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" 
              [attr.fill]="isPlaying(m, j) ? 'red' : 'currentColor'" class="bi mr-2 c-pointer" viewBox="0 0 16 16">
            <path *ngIf="!isPlaying(m, j)" d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
            <path *ngIf="isPlaying(m, j)" d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
          </svg>
          {{ m.song_name }} - {{ m.artist }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-1 d-flex align-items-center p-0">
      <svg (click)="removeRow('groups', i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
        class="bi bi-trash mr-2 c-pointer" viewBox="0 0 16 16">
        <path
          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
        <path
          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
      </svg>

      <svg (click)="newRow('groups')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
        class="bi bi-plus-lg c-pointer" viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
      </svg>
    </div>
  </div>
</section>

<section *ngIf="activeSource == 'claims'" class="mb-3">

  <div *ngFor="let claim of compData?.claims; let i = index" class="row align-items-center mb-3">
    <div class="col-md">
      <select (change)="topicChange($event, 'claims', i)"
        class="custom-select bg-transparent border-secondary text-light" style="min-height: 62px;">
        <option value="">Choose a claim topic</option>
        <option [value]="item?.topic" [selected]="compData?.claims[i]?.topic == item?.topic"
          *ngFor="let item of claimTopics">{{ item?.topic }}</option>
      </select>
    </div>

    <div *ngIf="hasClaimGroup" class="col-md-2">
      <input type="number" min="1" placeholder="Limit" aria-label="Limit, number of random songs from this topic"
        title="Random songs from this topic instead of picking songs"
        class="form-control bg-transparent border-secondary text-light" style="min-height: 62px;"
        [value]="claim?.limit || ''" [attr.max]="musicList?.claims[i]?.length"
        [disabled]="isEmptyTopic(claim?.topic) || claim?.musics?.length > 0 || !musicList?.claims[i]"
        (change)="limitChange('claims', i, $event.target.value); $event.target.value = claim?.limit || ''">
    </div>

    <mat-form-field appearance="fill" [class.col-md-4]="hasClaimGroup" [class.col-md-6]="!hasClaimGroup">
      <mat-label>Choose claim musics</mat-label>

      <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="compData?.claims[i]?.musics"
        [disabled]="claim?.limit > 0 && !claim?.musics?.length" (ngModelChange)="musicChange($event, 'claims', i)" multiple
        disableOptionCentering #claimSelect (openedChange)="$event && scrollPanelTop(claimSelect)">
        <mat-select-trigger class="text-light">
          {{ compData?.claims[i]?.musics ? compData?.claims[i].musics[0]?.title : '' }}
          <span *ngIf="compData?.claims[i]?.musics?.length > 1">
            (+{{ compData?.claims[i].musics.length - 1 }}
            {{ compData?.claims[i].musics.length == 2 ? 'other' : 'others' }})
          </span>
        </mat-select-trigger>

        <mat-optgroup>
          <mat-form-field class="w-100">
            <input matInput placeholder="Search" #claimFilter (keydown)="$event.stopPropagation()">
          </mat-form-field>
        </mat-optgroup>

        <mat-option [value]="m" *ngFor="let m of musicList?.claims[i]"
          [ngClass]="{ 'd-none': !(m?.id + ' ' + m?.title.toLowerCase() + ' ' + m?.artist.toLowerCase()).includes(claimFilter.value.toLowerCase()) }">
          <svg *ngIf="m.tier == 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-suit-heart-fill text-danger" viewBox="0 0 16 16">
            <path
              d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
          </svg>
          {{ m.id }} | {{ m.views | numberFormat }} views | {{ m.title }} - {{ m.artist }}
          {{m.count_week ? '(used ' + m.count_week + '/' + m.limit_week + ')' : ''}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-1 d-flex align-items-center p-0">
      <svg (click)="removeRow('claims', i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
        fill="currentColor" class="bi bi-trash mr-2 c-pointer" viewBox="0 0 16 16">
        <path
          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
        <path
          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
      </svg>

      <svg (click)="newRow('claims')" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
        fill="currentColor" class="bi bi-plus-lg c-pointer" viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
      </svg>
    </div>
  </div>
</section>

<section *ngIf="activeSource == 'promos'" class="mb-3">

  <div *ngFor="let promo of compData?.promos; let i = index" class="row align-items-center mb-3">
    <div class="col-md">
      <select (change)="topicChange($event, 'promos', i)"
        class="custom-select bg-transparent border-secondary text-light" style="min-height: 62px;">
        <option value="">Choose a promo topic</option>
        <option [value]="item?.topic" [selected]="compData?.promos[i]?.topic == item?.topic"
          *ngFor="let item of promoTopics">{{ item?.topic }}</option>
      </select>
    </div>

    <mat-form-field appearance="fill" class="col-md-6">
      <mat-label>Choose promo musics</mat-label>

      <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="compData?.promos[i].musics"
        (ngModelChange)="musicChange($event, 'promos', i)" multiple
        disableOptionCentering #promoSelect (openedChange)="$event && scrollPanelTop(promoSelect)">
        <mat-select-trigger class="text-light">
          {{ compData?.promos[i]?.musics ? compData?.promos[i].musics[0]?.title : '' }}
          <span *ngIf="compData?.promos[i]?.musics?.length > 1">
            (+{{ compData?.promos[i].musics.length - 1 }}
            {{ compData?.promos[i].musics.length == 2 ? 'other' : 'others' }})
          </span>
        </mat-select-trigger>

        <mat-optgroup>
          <mat-form-field class="w-100">
            <input matInput placeholder="Search" #promoFilter (keydown)="$event.stopPropagation()">
          </mat-form-field>
        </mat-optgroup>

        <mat-option [value]="m" *ngFor="let m of musicList?.promos[i]"
          [ngClass]="{ 'd-none': !(m?.id + ' ' + m?.title.toLowerCase() + ' ' + m?.artist.toLowerCase()).includes(promoFilter.value.toLowerCase()) }">
          <svg *ngIf="m.tier == 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-suit-heart-fill text-danger" viewBox="0 0 16 16">
            <path
              d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
          </svg>
          {{ m.id }} | {{ m.views_percent }}% | {{ m.label || 'N/A' }} - {{ m.title }} {{m.count_week ? '(used '
          + m.count_week + '/' + m.limit_week + ')' : ''}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-1 d-flex align-items-center p-0">
      <svg (click)="removeRow('promos', i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
        fill="currentColor" class="bi bi-trash mr-2 c-pointer" viewBox="0 0 16 16">
        <path
          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
        <path
          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
      </svg>

      <svg (click)="newRow('promos')" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
        fill="currentColor" class="bi bi-plus-lg c-pointer" viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
      </svg>
    </div>
  </div>
</section>

<section class="border border-primary rounded p-2 mb-3">
  <div class="d-flex align-items-center mb-2 small">
    <span class="font-weight-bold text-white-50">Tracks</span>
    <span class="badge badge-pill badge-light ml-2">{{ editorService.countTracks(tracks) }}</span>
    <span *ngIf="tracks?.length" class="ml-auto text-white-50">{{ editorService.totalTimestamp(tracks) }}</span>
    <button *ngIf="tracks?.length" type="button" class="btn btn-sm btn-link text-light p-0 ml-3"
      (click)="isTracksExpanded = !isTracksExpanded">{{ isTracksExpanded ? 'Collapse' : 'Expand' }}</button>
  </div>

  <div *ngIf="!tracks?.length" class="text-center text-white-50 small py-3">No tracks yet. Paste links or pick from Boom DB, Groups, Claim, Promo.</div>

  <ul class="list-group list-group-flush overflow-auto" [style.max-height]="isTracksExpanded ? 'none' : '55vh'" cdkDropList (cdkDropListDropped)="trackDrop($event)"
    *ngIf="tracks?.length">
    <ng-container *ngFor="let item of tracks; let i = index">
      <li class="list-group-item text-light"
        [class.bg-dark]="!['EPIC', 'OFFICIAL', 'AI', 'SYMP'].includes(item?.music_type) && !isClaimOrPromo(item)"
        [class.bg-success]="item?.music_type === 'EPIC'"
        [class.bg-info]="item?.music_type === 'OFFICIAL'"
        [class.bg-secondary]="item?.music_type === 'AI'"
        [class.bg-purple]="item?.music_type === 'SYMP'"
        [class.bg-warning]="isClaimOrPromo(item)"
        [class.border-danger]="hasValidationError(i)"
        [class.border-warning]="editingTrack === item"
        [style.border-width]="hasValidationError(i) || editingTrack === item ? '2px' : '1px'"
        *ngIf="!item?.uri.includes('automusic:source')" cdkDrag>
        <div class="form-row d-flex align-items-center">
          <div class="col-md-1 d-flex align-items-center justify-content-between">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-grip-horizontal" viewBox="0 0 16 16">
              <path
                d="M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </svg>

            <div *ngIf="fukArtists?.has(item?.artist_name?.toLowerCase())" data-toggle="tooltip" data-placement="top" title="This artist FUK your channel">⛔</div>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-youtube" viewBox="0 0 16 16" *ngIf="item?.type == 3">
              <path
                d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
            </svg>

            <img height="16px" src="/assets/images/spotify.png" *ngIf="item?.type == 6">

            <img height="16px" src="/assets/images/deezer.png"
              *ngIf="item?.type == 7 && !item.hasOwnProperty('boom_deezer_id')">

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-circle-fill" viewBox="0 0 16 16"
              *ngIf="(item?.type == 7 || item?.type == 10) && item.hasOwnProperty('boom_deezer_id')">
              <circle cx="8" cy="8" r="8" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-file-earmark-music-fill" viewBox="0 0 16 16"
              *ngIf="item?.type == 8 || item?.type == 9">
              <path
                d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 6.64v1.75l-2 .5v3.61c0 .495-.301.883-.662 1.123C7.974 13.866 7.499 14 7 14c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 11.134 6.501 11 7 11c.356 0 .7.068 1 .196V6.89a1 1 0 0 1 .757-.97l1-.25A1 1 0 0 1 11 6.64z" />
            </svg>

            <img height="16px" src="/assets/images/soundhex.png"
              *ngIf="item?.type == 10 && !item.hasOwnProperty('boom_deezer_id')">

            <svg *ngIf="isGroupTrack(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-currency-dollar" viewBox="0 0 16 16">
              <path
                d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73z" />
            </svg>
          </div>

          <div class="col-md-4 text-truncate" *ngIf="item?.song_name" title="{{ item?.artist_name }} - {{ item?.song_name }}">
            {{ i + 1 }}. {{ item?.artist_name }} - {{ item?.song_name }}
          </div>

          <div class="col-md-4 text-truncate" *ngIf="isGroupTrack(item)" title="{{ groupTopic(item) }} - {{ item.limit }} songs">
            {{ i + 1 }}. {{ groupTopic(item) }} - {{ item.limit }} songs
          </div>

          <div class="col-md">
            <input *ngIf="editingTrack !== item" class="form-control form-control-sm bg-dark border-secondary text-light" type="text"
              value="{{ item?.uri.includes('music/hexa') ? item?.uri.split('/').slice(-1)[0] : item?.uri }}"
              disabled>

            <ng-container *ngIf="editingTrack === item">
              <mat-select *ngIf="editorService.parseMusicIdx(item.music_idx); else replaceLinkInput" #replaceSelect
                class="form-control form-control-sm bg-dark border-warning" aria-label="Replace with a song from the same source"
                [compareWith]="editorService.matCompareWithId" [value]="currentSourceItem(item)"
                (selectionChange)="replaceWith(item, $event.value)" (openedChange)="!$event && stopEditing()">
                <mat-select-trigger class="text-light">{{ musicLabel(currentSourceItem(item)) }}</mat-select-trigger>

                <mat-optgroup>
                  <mat-form-field class="w-100">
                    <input matInput placeholder="Search" #replaceFilter (keydown)="$event.stopPropagation()">
                  </mat-form-field>
                </mat-optgroup>

                <mat-option *ngIf="!replaceList.length" disabled>No songs loaded for this source</mat-option>
                <mat-option *ngFor="let m of replaceList" [value]="m"
                  [ngClass]="{ 'd-none': !(m?.id + ' ' + musicLabel(m)).toLowerCase().includes(replaceFilter.value.toLowerCase()) }">
                  {{ musicLabel(m) }}
                  <span *ngIf="isPicked(item, m)" class="badge badge-pill badge-warning ml-1">Added</span>
                </mat-option>
              </mat-select>

              <ng-template #replaceLinkInput>
                <input #replaceInput class="form-control form-control-sm bg-dark border-warning text-light" type="text"
                  aria-label="New link, Enter to replace, Esc to cancel" placeholder="Paste a new link, Enter to replace, Esc to cancel"
                  [value]="item.music_idx" (keydown.enter)="replaceLink(item, $event.target.value)"
                  (keydown.escape)="stopEditing()" (blur)="stopEditing()">
              </ng-template>
            </ng-container>
          </div>

          <div class="col-md-2 d-flex align-items-center">
            <svg *ngIf="item.direct_link" (click)="playAudio(item, i)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" 
                [attr.fill]="isPlaying(item, i) ? 'red' : 'currentColor'" class="bi mr-2 c-pointer" viewBox="0 0 16 16">
              <path *ngIf="!isPlaying(item, i)" d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
              <path *ngIf="isPlaying(item, i)" d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
            </svg>

            <ng-container *ngIf="item.music_idx">
              <svg (click)="cloneMusic(item)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy mr-2 c-pointer" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
              </svg>

              <button *ngIf="!isGroupTrack(item)" type="button" class="btn btn-link text-reset p-0 mr-2" (click)="editTrack(item)"
                title="Replace this track" aria-label="Replace this track">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil d-block" viewBox="0 0 16 16" aria-hidden="true">
                  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"/>
                </svg>
              </button>

              <svg (click)="deleteMusic(item, i)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash c-pointer" viewBox="0 0 16 16">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
              </svg>
            </ng-container>

            <ng-container *ngIf="mode == 'mix_lyric'">
              <input (change)="item.has_lyric = $event.target.checked"
                [checked]="item?.has_lyric || (item?.has_lyric === undefined && i < 3)" type="checkbox"
                [id]="'hasLyric' + i" class="d-none">
              <label class="form-check-label c-pointer ml-2 mb-0" [for]="'hasLyric' + i" title="Has lyric">
                <svg viewBox="0 0 16 16" width="16" height="16"
                  [attr.fill]="item?.has_lyric || (item?.has_lyric === undefined && i < 3) ? 'cyan' : 'gray'"
                  class="bi bi-music-lyric">
                  <path d="M15 4.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0zm1 0a4.5 4.5 0 0 1-5.099 4.46L3.048 15 0 12l7-7.58v.08a4.5 4.5 0 1 1 9 0zM7.166 5.715l-5.774 6.252 1.736 1.71 6.57-5.053a4.511 4.511 0 0 1-2.532-2.91z"/>
                </svg>
              </label>
            </ng-container>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>
</section>
